// One file type mapping is shared by list/grid and retained when an image fails.
const groups = {
  word: ['doc', 'docx', 'docm', 'dot', 'dotx', 'dotm', 'rtf', 'odt', 'wps', 'wpt'],
  excel: ['xls', 'xlsx', 'xlsm', 'xlsb', 'xlt', 'xltx', 'xltm', 'csv', 'tsv', 'ods', 'et', 'ett'],
  powerpoint: ['ppt', 'pptx', 'pptm', 'pps', 'ppsx', 'ppsm', 'pot', 'potx', 'potm', 'odp', 'dps', 'dpt'],
  pdf: ['pdf'],
  text: ['txt', 'text', 'md', 'log'],
  archive: ['zip', 'rar', '7z', 'tar', 'gz', 'tgz', 'bz2', 'xz'],
  image: ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg', 'tif', 'tiff', 'heic', 'heif', 'ico'],
  video: ['mp4', 'mov', 'avi', 'mkv', 'webm', 'wmv', 'm4v', 'flv'],
  audio: ['mp3', 'wav', 'm4a', 'aac', 'ogg', 'flac', 'wma']
}
export function fileIconKind(row) {
  if (row.kind === 'DIR') return 'folder'
  const name = String(row.name || '').trim(), dot = name.lastIndexOf('.')
  const ext = dot > -1 ? name.slice(dot + 1).toLowerCase() : ''
  for (const kind of Object.keys(groups)) if (groups[kind].includes(ext)) return kind
  const mime = String(row.mediaType || '').toLowerCase().split(';')[0].trim()
  if (mime === 'application/pdf') return 'pdf'
  if (/^(image|video|audio)\//.test(mime)) return mime.split('/')[0]
  if (/^(text\/csv|application\/vnd\.ms-excel)$/.test(mime) || mime.includes('spreadsheetml')) return 'excel'
  if (mime === 'application/msword' || mime.includes('wordprocessingml')) return 'word'
  if (mime === 'application/vnd.ms-powerpoint' || mime.includes('presentationml')) return 'powerpoint'
  if (mime.startsWith('text/')) return 'text'
  return 'file'
}
